import { dateFormatter2 as dateFormatter, DateFormatTypes } from '@jfs/utils'
import { Link } from '../../data/models/Links'

const createPaymentLinkParser = (data: any) => {
  const newLink = Link.create({
    id: data?.id ?? 'NA',
    jioLinkId: data?.jioLinkId ?? '',
    url: data?.url ?? '',
    createdAt: dateFormatter(data?.createdAt ?? 'NA', DateFormatTypes.DD_MMM_YYYY_FROM_YYYYMMDD),
    status: data?.linkStatus ?? '',
    amount: data?.amount ?? '',
    merchantLinkId: data?.merchantLinkId ?? '',
    linkExpiryAt: data?.linkExpiryAt ?? '',
    invoice: data?.invoice ?? '',
    description: data?.description ?? '',
    pushSmsTo: data?.pushSmsTo ?? '',
    pushEmailTo: data?.pushEmailTo ?? '',
    merchantReturnUrl: data?.merchantReturnUrl ?? '',
    merchantCallBackUrl: data?.merchantCallBackUrl ?? '',
    customerName: data?.customerName ?? '',
  })
  return { link: newLink }
}
export { createPaymentLinkParser }
